import { Search } from 'lucide-react';
import React, { useCallback } from 'react';

import { Input } from '../../../atoms/input/input';
import { ITextFilter } from '../filter-utils';

export const GlobalSearch: React.FC<IGlobalSearchProps> = ({ globalFilter }) => {
  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const { value } = e.target;
      globalFilter?.onChange(value);
    },
    [globalFilter]
  );

  if (!globalFilter) return null;

  return (
    <div className="w-full min-w-[150px] max-w-[306px]">
      <Input
        aria-label="Global search"
        icon={Search}
        onChange={handleChange}
        placeholder="Search"
        size="small"
        type="text"
        value={globalFilter.value ?? ''}
      />
    </div>
  );
};

export interface IGlobalSearchProps {
  globalFilter?: Pick<ITextFilter, 'value' | 'onChange'>;
}
